import {
  call, put, select, takeEvery,
} from "redux-saga/effects";
import { setTableData, setTableTotalData } from "@fas/cpa-state-manager/redux/actions";
import { GET_DASHBOARD_DATA_SAGA } from "@fas/cpa-state-manager/redux/constants";
import { getTableFilters } from "@fas/cpa-state-manager/services/selectors/table";
import setLoading from "@fas/cpa-state-manager/redux/actions/loading/actions";
import { getDashboard } from "../../services/dashboardApi";
import type { Params, Data, Filters, Fields, ItemData } from "../../services/dashboardApi";
import { formatDateByGroup, getGroupByDateRange, prepareFilters } from "../../helpers/generators";
import { DASHBOARD_TABLE } from "../../helpers/constants";

export type DataResponce = {
  data: Data
};

export function* makeFetch() {
  try {
    yield put(setLoading("getDashboardDataLoading", true));
    const filters: Filters = yield select(getTableFilters, DASHBOARD_TABLE);
    const fields: Fields[] = [
      "date",
    ];
    const group = {
      date: getGroupByDateRange(filters.dateFrom, filters.dateTo),
      department: false,
    };
    
    const response: DataResponce = yield call(getDashboard, {
      filters: prepareFilters(filters),
      fields,
      group,
      limit: 100,
    } as Params);
    const data = response.data.result.map((item: ItemData) => ({
      ...item,
      date: formatDateByGroup(item.date, group.date),
    }));
    yield put(setTableData(DASHBOARD_TABLE, data));
    yield put(setTableTotalData(DASHBOARD_TABLE, response.data.total.result));
  }
  catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  finally {
    yield put(setLoading("getDashboardDataLoading", false));
  }
}

export default function* watchGetDashboardDataSaga() {
  yield takeEvery(GET_DASHBOARD_DATA_SAGA, (makeFetch));
}
